module.exports = __webpack_public_path__ + "img/4.bba021f9.jpg";